import { render, staticRenderFns } from "./RolePlayForm.vue?vue&type=template&id=4868e964&"
import script from "./RolePlayForm.vue?vue&type=script&lang=js&"
export * from "./RolePlayForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports